<template>
  <div class="ref-state" :class="{ 'ref-state--compact': compact }" role="status" aria-live="polite">
    <van-loading v-if="loading" color="#b66bae" size="24" />
    <van-icon v-else :name="error ? 'warning-o' : 'photo-o'" size="30" />
    <p>{{ loading ? $t('frontend.common.loading') : error || empty || $t('frontend.common.empty') }}</p>
    <button v-if="error" type="button" class="ref-text-button" @click="$emit('retry')">{{ $t('frontend.common.reload') }}</button>
  </div>
</template>
<script>
export default {
  props: {
    loading: Boolean,
    error: { type: String, default: "" },
    empty: { type: String, default: "" },
    compact: Boolean
  }
};
</script>
